/* bfcm-yog.js - "Win 1 Year of Golf" giveaway (preview build).
   Acts only while <html data-gd-yog="on"> (snippets/bfcm-yog.liquid writes it
   from ?gd_yog=on or the Intelligems arm). The attribute is read at the moment
   of each tap, never at load: the arm can land after this file has run.
   Three jobs: open the ways-to-enter sheet, send the sale bar's tap to the
   sheet, and keep the cart strip's entry count in step with the cart. */
(function () {
  const root = document.documentElement;
  const isOn = () => root.getAttribute('data-gd-yog') === 'on';

  const BUNDLE_HANDLES = ['benchmarkgolf-launch-bundle', 'benchmarkgolf-launch-bundle-plus', 'the-benchmark-launch-bundle'];
  const MAT_HANDLE = 'golf-at-home';
  const ENTRY_CAP = 400;

  const sheet = () => document.getElementById('BmYogSheet');

  const openSheet = () => {
    const el = sheet();
    if (!el) return;
    if (typeof el.showModal === 'function') {
      if (!el.open) el.showModal();
    } else {
      el.setAttribute('open', '');
    }
  };

  const closeSheet = () => {
    const el = sheet();
    if (!el) return;
    if (typeof el.close === 'function') el.close();
    else el.removeAttribute('open');
  };

  /* A pop-up row adds its item by pressing the page's OWN button, so every
     price test, arm swap and bundle tag behaves exactly as it does there:
     Golf At Home -> the buy box's Add to Cart, the bundle -> the bundle
     card's add button. Off the product page there is no such button, so the
     row goes to the Golf At Home page instead. */
  const visible = (el) => el && el.getClientRects().length > 0;
  const addFromRow = (row) => {
    const kind = row.getAttribute('data-yog-add');
    const buttons =
      kind === 'bundle'
        ? Array.from(document.querySelectorAll('.lb-cta[data-bm-bundle]:not([data-lb-sheet-close])'))
        : Array.from(document.querySelectorAll('.bb-atc'));
    const button = buttons.find(visible) || buttons[0];
    closeSheet();
    if (button) button.click();
    else window.location.href = '/products/golf-at-home';
  };
  document.addEventListener('keydown', (event) => {
    if (!isOn() || (event.key !== 'Enter' && event.key !== ' ')) return;
    const row = event.target.closest && event.target.closest('[data-yog-add]');
    if (!row) return;
    event.preventDefault();
    addFromRow(row);
  });

  /* capture phase: the header band is a link with its own scroll-to-buybox
     handler, and while the giveaway is on its tap answers "how do I enter" */
  document.addEventListener(
    'click',
    (event) => {
      if (!isOn()) return;
      const row = event.target.closest('[data-yog-add]');
      if (row) {
        event.preventDefault();
        event.stopPropagation();
        addFromRow(row);
        return;
      }
      /* the prize card under Add to Cart opens its details in place */
      const award = event.target.closest('[data-yog-award]');
      if (award) {
        event.preventDefault();
        const body = document.getElementById(award.getAttribute('aria-controls'));
        const open = award.getAttribute('aria-expanded') !== 'true';
        award.setAttribute('aria-expanded', String(open));
        if (body) body.hidden = !open;
        return;
      }
      if (event.target.closest('[data-yog-open]')) {
        event.preventDefault();
        event.stopPropagation();
        openSheet();
        return;
      }
      if (event.target.closest('.header-benchmark__salebar')) {
        event.preventDefault();
        event.stopImmediatePropagation();
        openSheet();
        return;
      }
      if (event.target.closest('[data-yog-close]')) {
        closeSheet();
        return;
      }
      /* a tap on the scrim lands on the dialog element itself */
      if (event.target === sheet()) closeSheet();
    },
    true
  );

  /* same sum as the 'cart' part of the snippet: 25 per Golf At Home, 100 per
     bundle, 400 for three bundles or more, 400 at most. Nothing else counts.
     A bundle's mat is its _bm_bundle_role 'main' line (one per bundle); the
     pads and coaching are 'item' lines and earn nothing. */
  const countEntries = (cart) => {
    let bundles = 0;
    let mats = 0;
    ((cart && cart.items) || []).forEach((item) => {
      const role = item.properties && item.properties._bm_bundle_role;
      if (role === 'main' || BUNDLE_HANDLES.includes(item.handle)) bundles += item.quantity;
      else if (role === 'item') return;
      else if (item.handle === MAT_HANDLE) mats += item.quantity;
    });
    const fromBundles = bundles >= 3 ? ENTRY_CAP : bundles * 100;
    return Math.min(ENTRY_CAP, fromBundles + mats * 25);
  };

  const paintCart = (cart) => {
    if (!cart || !Array.isArray(cart.items)) return;
    const entries = countEntries(cart);
    document.querySelectorAll('[data-yog-cart]').forEach((strip) => {
      strip.hidden = entries === 0;
      const count = strip.querySelector('[data-yog-count]');
      if (count) count.textContent = String(entries);
    });
  };

  document.addEventListener('cart:state-updated', (event) => {
    paintCart((event.detail && event.detail.cart) || window._cartState);
  });
  document.addEventListener('cart-drawer:show', () => {
    paintCart(window._cartState);
  });

  /* Not every cart change announces itself: the bundle stepper and the
     drawer's upgrade card rewrite the drawer without cart:state-updated, which
     left the strip at its first count (three bundles read 25). So recount from
     /cart.js whenever elements are added to or removed from the drawer.
     Text-only changes are skipped, which keeps out the ticking clocks and this
     strip's own count, so it never loops. Watching the document, not the
     drawer, survives the drawer element being swapped for a fresh render. */
  let recountTimer = 0;
  const recount = () => {
    clearTimeout(recountTimer);
    recountTimer = setTimeout(() => {
      if (!isOn() || !document.querySelector('[data-yog-cart]')) return;
      fetch('/cart.js', { cache: 'no-store', credentials: 'same-origin' })
        .then((response) => response.json())
        .then(paintCart)
        .catch(() => {});
    }, 400);
  };
  const isElement = (node) => node.nodeType === 1;
  const touchesDrawer = (record) =>
    record.target.closest &&
    record.target.closest('cart-drawer') &&
    !record.target.closest('[data-yog-cart]') &&
    (Array.from(record.addedNodes).some(isElement) || Array.from(record.removedNodes).some(isElement));
  new MutationObserver((records) => {
    if (!isOn()) return;
    if (records.some(touchesDrawer)) recount();
    /* a re-render can replace the element that carries the deadline */
    if (!document.querySelector('[data-yog-deadline-host]')) syncDeadline();
  }).observe(root, { childList: true, subtree: true });

  /* The challenge ends October 31 (Paul, 10-14). While the giveaway is on,
     its end date becomes data-sale-deadline, the one deadline the header bar,
     the bundle card and the PDP clock all read on every tick
     (assets/header-benchmark.js), so they count down to it in days. Off
     again (the control arm, ?gd_yog=off), the original value comes back. */
  /* on the header's clock first: the drawer is re-rendered after load and
     took the attribute with it (10-14, every clock fell back to midnight) */
  const HOST = 'data-yog-deadline-host';
  function syncDeadline() {
    const ends = (sheet() && sheet().dataset.yogEnds) || '';
    const el =
      document.querySelector('[' + HOST + ']') ||
      document.querySelector('[data-sale-deadline]') ||
      document.querySelector('.header-benchmark [data-sale-countdown]') ||
      document.querySelector('[data-sale-countdown]');
    if (!ends || !el) return;
    if (isOn()) {
      if (!el.hasAttribute(HOST)) el.setAttribute(HOST, el.getAttribute('data-sale-deadline') || '');
      el.setAttribute('data-sale-deadline', ends);
    } else if (el.hasAttribute(HOST)) {
      const original = el.getAttribute(HOST);
      if (original) el.setAttribute('data-sale-deadline', original);
      else el.removeAttribute('data-sale-deadline');
      el.removeAttribute(HOST);
    }
  }
  syncDeadline();
  /* the Intelligems arm can switch the giveaway on after this file has run */
  new MutationObserver(syncDeadline).observe(root, { attributes: true, attributeFilter: ['data-gd-yog'] });
})();
